<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id" :initialAttr="initialAttr">
        <div class="widget_menu">
            <!-- IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта): подпись — пропом :header обёртки (WjMenuBehavior._definedHeader); без него itemClicked → value → _updateHeader() стирает header в "" -->
            <wj-menu 
                :id="attr.html_id"
                :class="menuClass"
                v-uiHelp="uiHelpKey ? { key: uiHelpKey, vars: () => ({ summary: attr.uiHelpNow || '' }) } : null"
                :displayMemberPath="'titleAction'" 
                :subItemsPath="'attrs'" 
                :showDropDownButton="false"
                v-if="attr.visible !== false && attr.hide !== true && store?.eval_value(WIDGET, attr['v-if'], {}, attr)"
                :openOnHover="true"
                :isAnimated="false" 
                :itemsSource="itemsSourceMenu"
                :header="headerHtml"
                :initialized="initMenu" 
                :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
            >
                <!-- <i class="pi pi-bars"></i> -->
            </wj-menu>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { langVersion } from '@/i18n'   // IE 2026 09 24 / ODOO-341407: пересборка itemsSource после смены языка без reload
import { planApproval_headerKeep } from '@/utils/planApproval'   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта)

export default {
    props: {
        attr_id: String,
        widget_id: [String, Number],
        initialAttr: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        attr: {},
        WIDGET: {},
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    beforeUnmount() {
        this.store.attr_deregister(this)
    },
    watch: {
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): меню с подписью (attr.headerHtml — кнопка «Plan approval» шапки Баланса: чипы видов плана + подпись) — заголовок wj-menu
        headerHtml(v) { this.menuHeader_apply(v) },
        initialAttr(attr) {
            // ремоунта нет, если :key совпал — подхватываем новый объект вручную
            if (attr) { this.content_Changed() }
        },
    },
    methods: {
        content_Changed() {
            if (this.initialAttr) {
                // attr передан объектом — id в поиске не участвует (опционален);
                // регистрацию в реестре по id сохраняем
                this.attr = this.initialAttr
                if (this.attr_id != null) {
                    this.WIDGET.attrs_vueObj[this.attr_id] = this
                }
            } else {
                this.store.widget_attr_set(this)
            }
        },
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): заголовок wj-menu (innerHTML; разметку и экранирование даёт владелец кнопки — utils/planApproval.planApproval_headerHtml)
        menuHeader_apply(v) {
            const menu = this[this.attr?.html_id]
            if (!menu || v === undefined) return
            try { if (menu.header !== v) menu.header = v } catch (e) { /* меню пересоздаётся */ }
        },
        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта): вернуть подпись, если обёртка wijmo её стёрла (сразу и после обработчиков клика / окна подтверждения)
        menuHeader_keep(menu) {
            if (!this.headerHtml) return
            const m = menu || this[this.attr?.html_id]
            planApproval_headerKeep(m, this.headerHtml)
            setTimeout(() => planApproval_headerKeep(this[this.attr?.html_id] || m, this.headerHtml), 0)
        },
        initMenu(menu) {
            this[menu.hostElement.id] = menu
            if (this.headerHtml) this.menuHeader_apply(this.headerHtml)   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
            // IE 2026 08 21 (скрин Игоря 19:31): на телефоне тап по папке (subItems)
            // не доходит до itemClicked — перехватываем на дропдауне в capture-фазе
            // и раскрываем содержимое папки НА МЕСТЕ («‹ Back» — возврат)
            const drill = (e) => {
                if (!this.store.mobileUi?.on) return
                const el = e.target.closest?.('.wj-listbox-item')
                if (!el || !menu.dropDown?.contains(el)) return
                const items = [...menu.dropDown.querySelectorAll('.wj-listbox-item')]
                const item = menu.itemsSource?.[items.indexOf(el)]
                if (!item) return
                if (item.attrs?.length) {
                    e.stopPropagation(); e.preventDefault()
                    // IE 2026 08 22: INLINE — дети под пунктом, повторный тап сворачивает
                    const src = menu.itemsSource.slice()
                    const idx = src.indexOf(item)
                    if (idx < 0) return
                    const d0 = item._menuDepth || 0
                    if (item._menuOpen) {
                        let end = idx + 1
                        while (end < src.length && (src[end]._menuDepth || 0) > d0) end++
                        for (let j = idx + 1; j < end; j++) src[j]._menuOpen = false
                        src.splice(idx + 1, end - idx - 1)
                        item._menuOpen = false
                    } else {
                        const children = item.attrs.filter(a => a.use !== false && a.hidden !== true && this.store.checkAccess(a, this.WIDGET))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                        children.forEach(a => { a._menuDepth = d0 + 1 })
                        src.splice(idx + 1, 0, ...children)
                        item._menuOpen = true
                    }
                    menu.itemsSource = src
                    menu.selectedIndex = -1
                    setTimeout(() => { menu.isDroppedDown = true }, 50)
                    // IE 2026 08 23 (скрин Игоря 11:27): раскрытая папка у нижнего
                    // края — прокрутить панель: заголовок папки виден сверху, дети в кадре
                    if (item._menuOpen) setTimeout(() => {
                        const p = menu.dropDown
                        const el = p?.querySelectorAll?.('.wj-listbox-item')?.[idx]
                        if (el && p.scrollHeight > p.clientHeight + 4) {
                            const top = el.getBoundingClientRect().top - p.getBoundingClientRect().top + p.scrollTop
                            p.scrollTop = Math.max(0, Math.min(top - 8, p.scrollHeight - p.clientHeight))
                        }
                    }, 170)
                }
            }
            // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): меню внутри формы ячейки (панель ROW: «Approval») — список wijmo лежит в body с z-index 1500 (Control._POPUP_ZINDEX), а сама форма — z-index 9999:
            // список оказывался ПОД формой (виден лишь кусок, выступающий снизу; у высокой формы — не виден совсем: пункты «Reopen · Marketing director» не прочитать). Класс menu-over-form поднимает такой список над формой
            // (CSS ниже); меню таблицы и прочие меню — как были. Выключатель fe.ux.cellFormMenuOnTop (по умолчанию вкл.)
            menu.isDroppedDownChanged.addHandler(() => {
                const dd = menu.dropDown
                if (menu.isDroppedDown && dd && !dd._ovrForm) {
                    dd._ovrForm = true
                    try { if (this.store.setting('fe.ux.cellFormMenuOnTop', true) !== false && menu.hostElement.closest('.dropdown')) dd.classList.add('menu-over-form') } catch (e) { /* без подъёма: как было */ }
                }
            })
            menu.isDroppedDownChanged.addHandler(() => {
                if (!menu.isDroppedDown) this.menuHeader_keep(menu)   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта): список закрылся — подпись на месте
                if (this.store.mobileUi?.on) document.body.classList.toggle('wj-menu-open', menu.isDroppedDown)
                if (menu.isDroppedDown && menu.dropDown && !menu.dropDown._drillHooked) {
                    menu.dropDown._drillHooked = true
                    // click до панели не доходит (wijmo гасит/пересобирает) —
                    // ловим mousedown и touchstart
                    menu.dropDown.addEventListener('mousedown', drill, true)
                    menu.dropDown.addEventListener('touchstart', drill, true)
                }
            })
        },
        menuNodeClicked(menu) {
            let actionMenu = menu.itemsSource[menu.selectedIndex]
            // IE 2026 08 21 (скрин Игоря 19:31): на телефоне hover нет — тап по
            // папке (subItems, напр. «Command panel») раскрывает её содержимое
            // НА МЕСТЕ, первым пунктом «‹ Back» возврат к корню меню
            if (this.store.mobileUi?.on && actionMenu) {
                if (actionMenu._menuBack) {
                    menu.itemsSource = actionMenu._menuBack
                    setTimeout(() => { menu.isDroppedDown = true }, 0)
                    return
                }
                if (actionMenu.attrs?.length) {
                    const children = actionMenu.attrs.filter(a => a.use !== false && a.hidden !== true && this.store.checkAccess(a, this.WIDGET))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                    menu.itemsSource = [{ titleAction: '\u2039 ' + this.t('Back'), _menuBack: menu.itemsSource }, ...children]   // IE 2026 09 23 / ODOO-341407: i18n
                    setTimeout(() => { menu.isDroppedDown = true }, 0)
                    return
                }
            }
            let vueObj = this.WIDGET.vueObj
            // event с target=хост корневого меню — для методов, позиционирующихся
            // по кнопке (onFillColor/onRowStyleColor/onRowStyleCustom)
            const host = (this[this.attr.html_id] || menu).hostElement
            this.menuHeader_keep(menu)   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта)
            this.store.executeStoreMethod(vueObj, actionMenu, null, null, { target: host })
        },
    },
    computed: {
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: ключ по cssClass — только два известных меню шапки виджета (Compare / Approve plans);
        // прочие возможные использования AttrMenu.vue — без объяснения (пустой ключ, v-uiHelp не биндится)
        uiHelpKey() {
            if (this.attr?.uiHelp) return String(this.attr.uiHelp)   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): ключ из определения меню — Copy / Style таблицы (AttrGrid.set_commandPanel)
            const cls = String(this.attr?.cssClass || '')
            if (cls.includes('pi-arrow-right-arrow-left')) return 'widget.header.btn.compare'
            if (cls.includes('pi-verified')) return 'widget.header.btn.approve'
            return ''
        },
        headerHtml() { return typeof this.attr?.headerHtml === 'string' && this.attr.headerHtml ? this.attr.headerHtml : undefined },   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
        menuClass() {
            return [
                this.attr['cssClass'],
                'commandPanel-buttons-menu p-button-secondary p-button-sm mr-2 p-2', {
                'menu-labelled': !!this.headerHtml,   // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239)
                // 'p-button-active': this.attr.active,
            }]
        },
        itemsSourceMenu() {
            void langVersion.value   // IE 2026 09 24 / ODOO-341407: пункты переподписаны на месте — новый массив заставляет wijmo перерисовать список
            const items = []
            for (let item of this.attr?.attrs || []) {
                if (item.use === false || item.hidden === true || !this.store.checkAccess(item, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                    continue
                }
                items.push(item)
            }
            return items
        },
    },
}
</script>

<style>
.widget_menu .wj-template {
    display: none;
}
.pi-bold {
    font-size: larger;
    font-weight: bolder;
}
.commandPanel-buttons-menu .wj-template {
    display: none;
}
.wj-listbox-item {
    z-index: 99999;
    box-shadow: none !important;
}
/* IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): меню с подписью (attr.headerHtml) — поле заголовка wijmo видно,
   кнопка: иконка + точки видов плана + ▾ (с 03.11, см. ниже); шрифт интерфейса (не primeicons); наведение меняет только фон — ширина та же */
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-template { display: block; }
.widget_menu .commandPanel-buttons-menu.menu-labelled { display: inline-flex; align-items: center; width: auto; height: auto; min-height: 0; padding: 3px 9px !important;
    border: 1px solid var(--cs-chip-border, var(--surface-border, #b9c4f0)); border-radius: 7px; background: var(--surface-card, #fff); box-shadow: none; cursor: pointer; font-family: var(--ie-ui-font); }   /* IE 2026 11 03 / ODOO-5800 (заказ Игоря 03.11: «Сделай более лаконичный заголовок или иконку. Для формы меню утверждения»): цвета — токенами (тёмная тема без белого фона) */
.widget_menu .commandPanel-buttons-menu.menu-labelled:hover { background: var(--surface-hover, #f3f4f8); }
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-input,
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-input-group,
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-form-control { display: inline-flex; align-items: center; width: auto; height: auto; min-height: 0; padding: 0; border: 0; background: transparent; box-shadow: none; }
.widget_menu .commandPanel-buttons-menu.menu-labelled .wj-input-group-btn { display: none; }
/* IE 2026 11 03 / ODOO-5800 (заказ Игоря 03.11: «Сделай более лаконичный заголовок или иконку. Для формы меню утверждения»): компактная кнопка — иконка, по точке на вид плана, ▾ (≈45 px; текст видов — в Alt-подсказке) */
.widget_menu .commandPanel-buttons-menu.menu-labelled.pa-btn { padding: 3px 4px !important; }   /* IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта): 61 → ≈47 px (отступы, зазоры, размер иконки / точек / ▾) */
.pa-hdr { display: inline-flex; align-items: center; gap: 2px; white-space: nowrap; font-family: var(--ie-ui-font); font-size: 12.5px; line-height: 18px; color: var(--cs-panel-btn, var(--primary-color, #3346a8)); }
.pa-hdr .pa-hdr-icon { font-size: 12px; }   /* IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта) */
.pa-hdr .pa-dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: var(--cs-pa-autoplan, var(--text-color-secondary, #9aa1ab)); flex: 0 0 auto; }
.pa-hdr .pa-dot.pa-tone-processed { background: var(--cs-pa-processed, #3f5bd8); }
.pa-hdr .pa-dot.pa-tone-approved { background: var(--cs-pa-approved, #22a04b); }
.pa-hdr .pa-dot.pa-tone-changed { background: var(--cs-pa-changed, #e09a00); }
.pa-hdr .pa-dot.pa-tone-withdrawn { background: var(--cs-pa-withdrawn, #d23b3b); }
.pa-hdr .pa-hdr-caret { font-size: 8px; }   /* IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — кнопка шапки после выбора пункта): зазор 2, точка 6 */
.commandPanel-buttons-menu.menu-labelled.pa-tone-processed { border-color: var(--cs-pa-processed-border, color-mix(in srgb, #3f5bd8 40%, transparent)); }
.commandPanel-buttons-menu.menu-labelled.pa-tone-approved { border-color: var(--cs-pa-approved-border, color-mix(in srgb, #22a04b 40%, transparent)); }
.commandPanel-buttons-menu.menu-labelled.pa-tone-changed { border-color: var(--cs-pa-changed-border, color-mix(in srgb, #e09a00 45%, transparent)); }
.commandPanel-buttons-menu.menu-labelled.pa-tone-withdrawn { border-color: var(--cs-pa-withdrawn-border, color-mix(in srgb, #d23b3b 40%, transparent)); }
/* IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): список меню из формы ячейки — над формой (.dropdown, z-index 9999); wijmo кладёт его в body со своим z-index 1500 (inline) — отсюда !important.
   html body …×2 — выше мобильного правила body.mobile-ui .wj-dropdown-panel:has(.wj-menu-item-row) { z-index: 1500 !important } (0,3,1) */
html body .wj-dropdown-panel.menu-over-form.menu-over-form { z-index: 10060 !important; }
</style>